/**
 * Dhivehi (Thaana) message tree — the DEFAULT locale for this app. Key shape
 * must exactly match en.ts; completeness.spec.ts enforces it mechanically.
 *
 * Translation note (read before shipping): these strings were written by an
 * engineer, not reviewed by a native Dhivehi speaker or MIFCO's own staff.
 * Every key exists and every screen renders correctly in Thaana/RTL — that
 * part is verified — but the WORDING should get a native-speaker pass before
 * this goes in front of real fishermen. Flagged here rather than silently
 * shipped as "done".
 */
const dv = {
  app: {
    name: 'މަސްވެރިޔާ',
  },
  common: {
    loading: 'ލޯޑްވަނީ…',
    retry: 'އަލުން މަސައްކަތްކުރޭ',
    save: 'ރައްކާކުރޭ',
    cancel: 'ކެންސަލް',
    back: 'ފަހަތަށް',
    next: 'ކުރިއަށް',
    close: 'ބަންދުކުރޭ',
    ok: 'އޯކޭ',
    yes: 'އާނ',
    no: 'ނޫން',
    viewAll: 'ހުރިހާ',
    somethingWrong: 'މައްސަލައެއް ދިމާވެއްޖެ',
    noConnection: 'އިންޓަނެޓް ކަނެކްޝަން ނެތް. ސޭވްކުރެވިފައިވާ ޑޭޓާ ރައްކާތެރި.',
    requestId: 'ރެފަރެންސް: {{id}}',
    empty: 'އަދި މިތާ އެއްޗެއް ނެތް',
    optional: 'އިޚްތިޔާރީ',
  },
  nav: {
    home: 'ހޯމް',
    vessels: 'ދޯނިތައް',
    queue: 'ސަފު',
    bills: 'ބިލްތައް',
    payments: 'ފައިސާ',
    wallet: 'ވޮލެޓް',
    announcements: 'އިއުލާން',
    profile: 'ޕްރޮފައިލް',
  },
  auth: {
    title: 'ސައިން އިން ކުރައްވާ',
    subtitle: 'މިފްކޯގައި ރަޖިސްޓަރީ ކޮށްފައިވާ ފޯނު ނަންބަރު ޖައްސަވާ',
    phoneLabel: 'ފޯނު ނަންބަރު',
    phonePlaceholder: '7XXXXXX',
    sendCode: 'ކޯޑު ފޮނުވާ',
    sending: 'ފޮނުވަނީ…',
    codeSentTo: '{{phone}} އަށް 6 ޑިޖިޓް ކޯޑެއް ފޮނުވިއްޖެ',
    codeLabel: '6 ޑިޖިޓް ކޯޑު ޖައްސަވާ',
    verify: 'ޔަގީންކޮށް ސައިން އިން ކުރޭ',
    verifying: 'ބަލަނީ…',
    resendIn: '{{seconds}} ސިކުންތުން އަލުން ފޮނުވޭނެ',
    resendNow: 'އަލުން ކޯޑު ފޮނުވާ',
    changeNumber: 'ނަންބަރު ބަދަލުކުރޭ',
    invalidPhone: 'ރަޖިސްޓަރީ ކޮށްފައިވާ ފޯނު ނަންބަރު ޖައްސަވާ.',
    invalidCode: 'ކޯޑު ރަނގަޅެއް ނޫން. އެސްއެމްއެސް ބައްލަވާފައި އަލުން މަސައްކަތްކުރައްވާ.',
    codeExpired: 'މި ކޯޑުގެ މުއްދަތު ހަމަވެއްޖެ. އައު ކޯޑެއް ފޮނުވާ.',
    tooManyAttempts: 'ވަރަށް ގިނަ ފަހަރު މަސައްކަތްކުރެވިއްޖެ. ކުޑައިރުކޮޅަކަށްފަހު އަލުން މަސައްކަތްކުރައްވާ.',
    signedOut: 'ސައިން އައުޓް ވެއްޖެ.',
    devOtpHint: 'ޑިވެލޮޕްމަންޓް އެކަނި: 000000 ކޯޑު ހަމައެކަނި ބޭނުންކުރެވޭނެ.',
  },
  home: {
    greeting: 'މަރުޙަބާ',
    walletBalance: 'ތިޔަބޭފުޅާގެ ވޮލެޓްގައި ހުރި ފައިސާ',
    pendingBillsNote: 'ކަށަވަރުކުރަން އިންތިޒާރުގައިވާ ބިލްތައް އަދި މި ބާކީގައި ނުހިމެނޭ.',
    goToWallet: 'ސްޓޭޓްމަންޓް ބައްލަވާ',
    todayQueue: 'މިއަދުގެ ސަފު',
    noActiveToken: 'ތިޔަބޭފުޅާގެ އެކްޓިވް ސަފު ޓޯކަނެއް ނެތް',
    joinQueue: 'ސަފުގައި ބައިވެރިވޭ',
    waitingAhead: 'ކުރީގައި {{count}} ދޯނި',
    waitingAheadZero: 'ދެން ތިޔަބޭފުޅާ',
    recentBills: 'އެންމެ ފަހުގެ ބިލްތައް',
    noBills: 'އަދި ބިލެއް ނެތް',
    announcementsUnread: 'ނުކިޔާ {{count}} އިއުލާން',
    announcementsUnreadPlural: 'ނުކިޔާ {{count}} އިއުލާން',
  },
  vessels: {
    title: 'ދޯނިތައް',
    empty: 'ތިޔަބޭފުޅާގެ ނަމުގައި ދޯންޏެއް އަދި ރަޖިސްޓަރީ ކޮށްފައެއް ނެތް.',
    relationOwner: 'ވެރިފަރާތް',
    relationCrew: 'ފަޅުވެރިޔާ',
    relationCrewRole: 'ފަޅުވެރިޔާ · {{role}}',
    registration: 'ރަޖިސްޓަރީ ނަންބަރު',
    island: 'ރަށް',
    atoll: 'އަތޮޅު',
    capacity: 'ކެޕޭސިޓީ',
    active: 'އެކްޓިވް',
    inactive: 'އިންއެކްޓިވް',
  },
  queue: {
    title: 'ސަފު',
    joinTitle: 'ސަފުގައި ބައިވެރިވޭ',
    collectionPoint: 'ކަލެކްޝަން ޕޮއިންޓް',
    selectCollectionPoint: 'ކަލެކްޝަން ޕޮއިންޓެއް ހޮއްވަވާ',
    vesselOptional: 'ދޯނި (އިޚްތިޔާރީ)',
    join: 'ޓޯކަނެއް ހޯއްދަވާ',
    joining: 'ޓޯކަން ހޯދަނީ…',
    yourToken: 'ތިޔަބޭފުޅާގެ ޓޯކަން',
    tokenNumber: 'ޓޯކަން {{number}}',
    servingLabel: 'މިހާރު ޚިދުމަތްދެނީ',
    servingNumber: 'މިހާރު ޚިދުމަތްދެނީ {{number}}',
    servingNone: 'އަދި ޓޯކަން ކިޔަން ފަށާފައެއް ނުވޭ',
    waitingAhead: 'ކުރީގައި {{count}} ދޯނި',
    waitingAheadPlural: 'ކުރީގައި {{count}} ދޯނި',
    waitingAheadZero: 'ދެން ތިޔަބޭފުޅާ — ތައްޔާރުވެލައްވާ',
    status: {
      waiting: 'އިންތިޒާރުކުރަނީ',
      called: 'ގޮވާލައިފި — ކައުންޓަރަށް ވަޑައިގަންނަވާ',
      serving: 'ޚިދުމަތްދެނީ',
      done: 'ނިމިއްޖެ',
      no_show: 'ވަޑައިނުގަތް',
    },
    issuedAt: 'ޓޯކަން ދޫކުރި ގަޑި {{time}}',
    refreshing: 'އައުކުރަނީ…',
    updatedAt: '{{time}} ގައި އައުކުރެވިއްޖެ',
    joinAnother: 'އިތުރު ޓޯކަނެއް ހޯއްދަވާ',
    noVessels: 'ތިޔަބޭފުޅާގެ ދޯންޏެއް ރެކޯޑުގައި ނެތް — އަދިވެސް ޓޯކަނެއް ހޯއްދެވިދާނެ.',
  },
  bills: {
    title: 'ބިލްތައް',
    filterAll: 'ހުރިހާ',
    kind: {
      fish: 'މަސް',
      ice: 'ސުޓޯ',
      diesel: 'ޑީސަލް',
    },
    status: {
      draft: 'ކަށަވަރުކުރަން އިންތިޒާރުގައި',
      finalized: 'ކަށަވަރުކޮށްފައި',
      voided: 'ބާތިލްކޮށްފައި',
    },
    noNumberYet: 'ކަށަވަރުކުރުމުން ނަންބަރު ދޫކުރެވޭނެ',
    empty: 'އަދި ބިލެއް ނެތް',
    loadMore: 'އިތުރަށް ދައްކާ',
    number: 'ބިލް ނަންބަރު',
    issuedAt: 'ދޫކުރި ތާރީޚް',
    net: 'ޖުމުލަ',
    viewDetail: 'ބިލް ބައްލަވާ',
  },
  billDetail: {
    title: 'ބިލް',
    draftNotice:
      'މިފްކޯއިން މި ބިލް އަދި ކަށަވަރުކޮށްފައެއް ނުވޭ. ތިރީގައިވާ ފައިސާ އަދި ތިޔަބޭފުޅާގެ ވޮލެޓް ބާކީގައި ނުހިމެނޭ. ބިލް ނަންބަރު ދޫކުރެވޭނީ ބިލް ކަށަވަރުކުރުމުންނެވެ.',
    gross: 'އުނިކުރުމުގެ ކުރިން',
    deductions: 'އުނިކުރުންތައް',
    net: 'ޖުމުލަ',
    status: 'ހާލަތު',
    issuedAt: 'ދޫކުރި ތާރީޚް',
    download: 'ޕީޑީއެފް ޑައުންލޯޑްކުރޭ',
    downloading: 'ޕީޑީއެފް ތައްޔާރުކުރަނީ…',
    downloadFailed: 'ޕީޑީއެފް ޑައުންލޯޑް ނުކުރެވުނު. އަލުން މަސައްކަތްކުރައްވާ.',
    notFound: 'މި ބިލެއް ނުފެނުނު.',
  },
  payments: {
    title: 'ފައިސާ ދެއްކި ތާރީޚް',
    empty: 'އަދި ފައިސާއެއް ދައްކާފައެއް ނެތް',
    loadMore: 'އިތުރަށް ދައްކާ',
    forBill: 'ބިލް {{number}} އަށް',
    method: {
      cash: 'ކޭޝް',
      bank_transfer: 'ބޭންކް ޓްރާންސްފަރ',
      wallet_offset: 'ވޮލެޓުން ދެއްކި',
    },
    paidAt: 'ދެއްކި ތާރީޚް',
  },
  wallet: {
    title: 'ވޮލެޓް',
    balance: 'މިހާރު ހުރި ބާކީ',
    asOf: '{{time}} އާ ހަމައަށް',
    statement: 'ސްޓޭޓްމަންޓް',
    empty: 'އަދި ވޮލެޓް ހަރަކާތެއް ނެތް',
    loadMore: 'އިތުރަށް ދައްކާ',
    balanceAfter: 'ފަހުން ބާކީ',
    debit: 'ދިޔަ ފައިސާ',
    credit: 'އައި ފައިސާ',
  },
  announcements: {
    title: 'އިއުލާން',
    empty: 'މިވަގުތު އިއުލާނެއް ނެތް',
    loadMore: 'އިތުރަށް ދައްކާ',
    unread: 'އައު',
    markingRead: 'ކިޔުނު ކަމަށް ފާހަގަކުރަނީ…',
  },
  profile: {
    title: 'ޕްރޮފައިލް',
    name: 'ނަން',
    phone: 'ފޯނު',
    address: 'އެޑްރެސް',
    island: 'ރަށް',
    atoll: 'އަތޮޅު',
    bankName: 'ބޭންކް',
    bankAccount: 'ބޭންކް އެކައުންޓް',
    edit: 'ޕްރޮފައިލް އެޑިޓްކުރޭ',
    editTitle: 'ޕްރޮފައިލް އެޑިޓްކުރޭ',
    save: 'ބަދަލުތައް ރައްކާކުރޭ',
    saving: 'ރައްކާކުރަނީ…',
    saved: 'ޕްރޮފައިލް އައުކުރެވިއްޖެ',
    bankChangeNotice:
      'ބޭންކް އެކައުންޓް ބަދަލުކުރަން ތިޔަބޭފުޅާ އެދިވަޑައިގެންފި. ސްޓާފް މެންބަރަކު މިކަން ބައްލަވާލެއްވުމަށްފަހު ނޫނީ މިކަން ތަންފީޒެއް ނުވާނެ — ބޭންކް އެކައުންޓް މިހާރުން މިހާރަކަށް ބަދަލެއް ނުވާނެ.',
    pendingBankChange: 'ބޭންކް އެކައުންޓް ބަދަލުކުރުން ބަލައި ނިމެންދެން',
    pendingSince: '{{time}} ގައި ހުށަހަޅުއްވައިފި',
    status: {
      active: 'އެކްޓިވް',
      suspended: 'ސަސްޕެންޑްކޮށްފައި',
      archived: 'އާކައިވްކޮށްފައި',
    },
    appearance: 'ފެންނަގޮތް',
    theme: {
      label: 'ތީމް',
      light: 'ލައިޓް',
      dark: 'ޑާކް',
      system: 'ޑިވައިސްއާ އެއްގޮތަށް',
    },
    language: 'ބަސް',
    languageDv: 'ދިވެހި',
    languageEn: 'އިނގިރޭސި',
    logout: 'ސައިން އައުޓް',
    confirmLogoutTitle: 'ސައިން އައުޓް ކުރައްވަނީތޯ؟',
    confirmLogoutBody: 'އަލުން ސައިން އިން ކުރައްވަން ފޯނު ނަންބަރު ބޭނުންވާނެ.',
  },
  sportsPublic: {
    title: 'ސްޕޯޓްސް ފިޝިންގ — ގަތުމުގެ ޝަރުތުތައް',
    empty: 'މިވަގުތު ހުޅުވިފައިވާ ޝަރުތެއް ނެތް',
    remainingLabel: 'ބާކީ',
    remainingKg: 'ބާކީ {{kg}}',
    targetKg: 'ޓާގެޓް {{kg}}',
    targetLabel: 'ޓާގެޓް',
    rate: 'ކިލޯއަކަށް {{amount}}',
    rateLabel: 'ރޭޓް',
    window: '{{from}} – {{to}}',
    status: {
      draft: 'އަދި ނުހުޅުވޭ',
      published: 'ހުޅުވިފައި',
      closed: 'ބަންދުކޮށްފައި',
    },
    collectionPoint: 'ކަލެކްޝަން ޕޮއިންޓް',
    viewDetail: 'ތަފްޞީލް ބައްލަވާ',
    register: 'ސްޕޯޓްސް ފިޝިންގއަށް ރަޖިސްޓަރީ ކުރައްވާ',
    nationalIdLabel: 'ދިވެހި ރައްޔިތެއްކަން އަންގައިދޭ ކާޑު ނަންބަރު',
    nationalIdPlaceholder: 'A123456',
    continue: 'ކުރިއަށް',
    notFound: 'މި ކާޑު ނަންބަރާ ދިމާވާ މަސްވެރިއެއް ނެތް.',
    otpSentTo: '{{phone}} އަށް ކޯޑެއް ފޮނުވިއްޖެ',
    activated: 'ސްޕޯޓްސް ފިޝިންގއަށް ރަޖިސްޓަރީ ވެއްޖެ.',
    signInInstead: 'މިހާރުވެސް ރަޖިސްޓަރީވެފައިވޭތޯ؟ ޕޯޓަލްއަށް ސައިން އިން ކުރައްވާ',
  },
  collectionPoint: {
    title: 'ކަލެކްޝަން ޕޮއިންޓް',
    atoll: 'އަތޮޅު',
    island: 'ރަށް',
    type: 'ބާވަތް',
    inactive: 'މިހާރު ޚިދުމަތެއް ނުދޭ',
  },
  verify: {
    title: 'ރަސީދު ޔަގީންކުރުން',
    subtitle: 'މިފްކޯ ރަސީދެއްގެ QR ކޯޑު ސްކޭންކޮށްފައި މިތާ ބައްލަވާ',
    number: 'ބިލް ނަންބަރު',
    issuedAt: 'ދޫކުރި ތާރީޚް',
    vessel: 'ދޯނި',
    total: 'ޖުމުލަ ފައިސާ',
    valid: 'މި ރަސީދަކީ ސައްހަ ރަސީދެއް',
    pending: 'މި ރަސީދު ރެކޯޑްކޮށްފައިވޭ — ކަށަވަރުކުރަން އިންތިޒާރުގައި',
    pendingNote:
      'މިފްކޯއިން މި ރަސީދު އަދި ކަށަވަރުކޮށްފައެއް ނުވޭ. މަތީގައިވާ ފައިސާއަކީ ބަރުދަން ބެލި މިންވަރު، އަދި ދޫކުރެވޭ ފައިސާއެއް ނޫން: ބިލް ނަންބަރެއް ދޫކޮށްފައެއް ނުވޭ، އަދި ތިޔަބޭފުޅާގެ ވޮލެޓް ބާކީގައި ނުހިމެނޭ. ރަސީދު ބެހެއްޓެވުމަށްފަހު، ކަލެކްޝަން ޕޮއިންޓުން ކަށަވަރުކުރުމުން އަލުން ބައްލަވާ.',
    reversed: 'ބާތިލްކޮށްފައި',
    reversedAt: 'ބާތިލްކުރި ތާރީޚް',
    reversedNote: 'މި މަސް ބަރުދަން ރެކޯޑްކޮށް ކަށަވަރުކުރުމަށްފަހު ފަހުން ބާތިލްކޮށްފައިވެއެވެ. މި އަދަދު މިހާރު ދޭންޖެހޭ އަދަދެއް ނޫން، އަދި ތިޔަ ބާކީގައި ނުހިމެނެއެވެ. މިކަން އުއްމީދުނުކުރާނަމަ ކަލެކްޝަން ޕޮއިންޓުގައި އައްސަވާ.',
    reference: 'ރެފަރެންސް',
    notFound: 'މި ކޯޑާ ދިމާވާ ރަސީދެއް ނެތް. ކޯޑު ރަނގަޅުތޯ ބައްލަވާ.',
    unavailable: 'މިވަގުތު މި ރަސީދު ބެލޭގޮތެއް ނުވި. ކަނެކްޝަން ބައްލަވާފައި އަލުން މަސައްކަތްކުރައްވާ — މިއީ ރަސީދު ސައްހަ ނޫން ކަމަކަށް ނުވޭ.',
    invalidCode: 'މި ކޯޑު ކިޔޭގޮތެއް ނުވި.',
  },
  errors: {
    network_error: 'އިންޓަނެޓް ކަނެކްޝަން ނެތް. ސިގްނަލް ބައްލަވާފައި އަލުން މަސައްކަތްކުރައްވާ.',
    timeout: 'ވަގުތު ހަމަވެއްޖެ. އަލުން މަސައްކަތްކުރައްވާ.',
    aborted: 'ކެންސަލްކުރެވިއްޖެ.',
    malformed_response: 'ސާވަރުން ބަލައިނުގަނެވޭ ޖަވާބެއް ލިބިއްޖެ. އަލުން މަސައްކަތްކުރައްވާ.',
    validation_failed: 'ފާހަގަކުރެވިފައިވާ ފީލްޑްތައް ބައްލަވާ.',
    not_found: 'ނުފެނުނު.',
    conflict: 'މިހާރު މިކަން ބަދަލުވެއްޖެ — އައުކޮށްފައި އަލުން މަސައްކަތްކުރައްވާ.',
    unauthenticated: 'ދޭތެރެ ސައިން އިން ކުރައްވާ.',
    forbidden: 'މިއަށް ތިޔަބޭފުޅާއަށް ވަދެވަޑައިނުގަނެވޭނެ.',
    rate_limited: 'ވަރަށް ގިނަ ފަހަރު މަސައްކަތްކުރެވިއްޖެ. ކުޑައިރުކޮޅަކަށްފަހު އަލުން މަސައްކަތްކުރައްވާ.',
    otp_invalid: 'ކޯޑު ރަނގަޅެއް ނޫން.',
    otp_expired: 'މި ކޯޑުގެ މުއްދަތު ހަމަވެއްޖެ.',
    service_unavailable: 'ޚިދުމަތް މިވަގުތު ލިބެން ނެތް.',
    internal_error: 'ސާވަރުގައި މައްސަލައެއް ދިމާވެއްޖެ.',
    generic: 'މައްސަލައެއް ދިމާވެއްޖެ. އަލުން މަސައްކަތްކުރައްވާ.',
  },
  notFound: {
    title: 'ސަފުހާ ނުފެނުނު',
    body: 'ތިޔަބޭފުޅާ ހޯއްދަވާ ސަފުހާ ނެތް.',
    goHome: 'ހޯމްއަށް ދާ',
  },
}

export default dv
